import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IFile } from 'src/models/file.model';
import services from 'src/services/file.service';

export const actionTypes = {
  FILE_UPLOAD: 'FILE_UPLOAD',
  FILE_DELETE: 'FILE_DELETE',
  FILE_DOWNLOAD: 'FILE_DOWNLOAD',
  FILE_LIST_FETCH: 'FILE_LIST_FETCH',
  FILE_ADD_DATA: 'FILE_ADD_DATA',
  FILE_DELETE_DATA: 'FILE_DELETE_DATA',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  uploadPOST: {
    type: actionTypes.FILE_UPLOAD,
    service: services.uploadPOST,
    meta: { error: false },
  },
  uploadDELETE: {
    type: actionTypes.FILE_DELETE,
    service: services.uploadDELETE,
  },
  downloadGET: {
    type: actionTypes.FILE_DOWNLOAD,
    service: services.downloadGET,
  },
  listByRequestIdGET: {
    type: actionTypes.FILE_LIST_FETCH,
    service: services.listByRequestIdGET,
  },
  addPOST: {
    type: actionTypes.FILE_ADD_DATA,
    service: services.addPOST,
    meta: { error: false },
  },
  dataDELETE: {
    type: actionTypes.FILE_DELETE_DATA,
    service: services.dataDELETE,
  },
};

export type IFileAsync = typeof asyncActions;

export const syncActions = {
  append: (data: IFile | IFile[]) => ({
    type: actionTypes.FILE_UPLOAD,
    payload: data,
  }),
  remove: (data: IFile) => ({
    type: actionTypes.FILE_DELETE,
    payload: data,
  }),
};

export type IFileSync = typeof syncActions;
export interface IFileState extends ICommonState<IFileAsync & IFileSync> {
  data?: IFile;
  list: IFile[];
}

export const defaultState: IFileState = {
  status: {},
  list: [],
};

const FileReducer = (
  state: IFileState = defaultState,
  action: IReducerAction<IFileAsync & IFileSync>
): IFileState => {
  switch (action.type) {
    case actionTypes.FILE_UPLOAD: {
      if (action.payload) {
        if (Array.isArray(action.payload)) {
          return {
            ...state,
            list: [...state.list, ...action.payload],
          };
        }

        return {
          ...state,
          data: action.payload,
          list: [...state.list],
        };
      }

      return state;
    }

    case actionTypes.FILE_DELETE: {
      return {
        ...state,
        list: state.list.filter(
          (value) => value.fileName !== action.payload?.fileName
        ),
      };
    }

    case actionTypes.FILE_LIST_FETCH: {
      return {
        ...state,
        list: action.payload?.rows ?? [],
      };
    }

    case actionTypes.FILE_ADD_DATA: {
      if (action.payload) {
        return {
          ...state,
          list: [...state.list, action.payload],
        };
      }

      return state;
    }

    case actionTypes.FILE_DELETE_DATA: {
      if (action.params) {
        const [uploadId] = action.params;

        return {
          ...state,
          list: state.list.filter((file) => file.uploadId !== uploadId),
        };
      }

      return state;
    }

    default: {
      return state;
    }
  }
};

export default FileReducer;
